/**
 * Public support / feedback inbox (baked at build via REACT_APP_SUPPORT_EMAIL).
 * Legal/privacy stays on privacy@clarcv.com — see Privacy / Terms pages.
 */

export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'hola@clarcv.com';

export const PRIVACY_EMAIL = 'privacy@clarcv.com';

/**
 * Build a mailto URL with optional subject and body.
 *
 * @param {object} options
 * @param {string} [options.email]
 * @param {string} [options.subject]
 * @param {string} [options.body]
 * @returns {string}
 */
export const buildMailto = ({ email = SUPPORT_EMAIL, subject = '', body = '' } = {}) => {
  const parts = [];
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  if (body) parts.push(`body=${encodeURIComponent(body)}`);
  return parts.length ? `mailto:${email}?${parts.join('&')}` : `mailto:${email}`;
};
